<template>
  <transition name="modal-fade">
    <div v-if="show" class="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm">
      <div class="w-full max-w-sm bg-white rounded-2xl shadow-2xl p-8 text-center">
        <!-- Animated Progress -->
        <div class="relative w-24 h-24 mx-auto mb-6">
          <div class="absolute inset-0 border-4 border-blue-200 rounded-full"></div>
          <div 
            class="absolute inset-0 border-4 border-transparent border-t-blue-600 rounded-full animate-spin"
            style="animation-duration: 1s;"
          ></div>
          <div class="absolute inset-2 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-full flex items-center justify-center shadow-lg">
            <svg class="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
        </div>
        
        <h3 class="text-xl font-bold text-gray-900 mb-2">{{ title || $t('submissionProgress.title') }}</h3>
        <p class="text-gray-600 text-sm mb-4">{{ message || $t('submissionProgress.message') }}</p>
        
        <!-- Progress Bar -->
        <div class="bg-gray-200 rounded-full h-2 overflow-hidden">
          <div 
            class="h-full bg-gradient-to-r from-blue-500 to-indigo-600 rounded-full transition-all duration-500 ease-out"
            :style="{ width: `${progress}%` }"
          ></div>
        </div>
        <p class="text-xs text-gray-500 mt-2">{{ $t('submissionProgress.complete', { percent: progress }) }}</p>
        
        <!-- Step indicators -->
        <div v-if="steps.length > 0" class="mt-4 space-y-2">
          <div 
            v-for="(step, index) in steps" 
            :key="index"
            class="flex items-center gap-2 text-xs"
            :class="step.completed ? 'text-green-600' : 'text-gray-400'"
          >
            <svg v-if="step.completed" class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
            </svg>
            <svg v-else class="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
            </svg>
            <span>{{ step.label }}</span>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'SubmissionProgress',
  props: {
    show: { type: Boolean, default: false },
    title: { type: String, default: '' },
    message: { type: String, default: '' },
    progress: { type: Number, default: 0 },
    steps: { type: Array, default: () => [] }
  }
}
</script>

<style scoped>
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}
</style>